var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"left-container"},[_c('version-list',{ref:"versions"})],1),_c('div',{staticClass:"right-container"},[_c('version-info',{attrs:{"version-id":_vm.versionId},on:{"updated":_vm.updated}}),_c('version-story-list',{attrs:{"version-id":_vm.versionId}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }